import React from "react";
import { addLocaleData, IntlProvider } from "react-intl";
import "intl";
import "intl/locale-data/jsonp/gl";
import "intl/locale-data/jsonp/es";
import "intl/locale-data/jsonp/eu";
import "intl/locale-data/jsonp/en";
import glLocaleData from "react-intl/locale-data/gl";
import esLocaleData from "react-intl/locale-data/es";
import enLocaleData from "react-intl/locale-data/en";
import jpLocaleData from "react-intl/locale-data/ja";
import "moment/locale/gl";
import "moment/locale/es";
import "moment/locale/eu";
import moment from "moment";
import esMessages from "config/locales/es.json";
import glMessages from "config/locales/gl.json";
import enMessages from "config/locales/en.json";
import jpMessages from "config/locales/ja.json";
import { warn } from "utils/warn";
import { useAuthDataContext } from "components/auth";

const formats = {
  date: {
    compact: {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    },
  },
};

export const SUPPORTED_LOCALES = { GL: "gl", ES: "es", EN: "en", JA: "ja" };

const DEFAULT_LOCALE = SUPPORTED_LOCALES.ES;

const getSupportedLocale = locale => {
  if (Object.values(SUPPORTED_LOCALES).includes(locale)) {
    return locale;
  }

  warn(`El locale especificado no está soportado. Usando el locale por defecto "${DEFAULT_LOCALE}"`);
  return DEFAULT_LOCALE;
};

const LOCALE_DATA = new Map([
  [SUPPORTED_LOCALES.GL, glLocaleData],
  [SUPPORTED_LOCALES.ES, esLocaleData],
  [SUPPORTED_LOCALES.EN, enLocaleData],
  [SUPPORTED_LOCALES.JA, jpLocaleData],
]);

const getLocaleData = locale => LOCALE_DATA.get(locale);

const LOCALE_MESSAGES = new Map([
  [SUPPORTED_LOCALES.GL, glMessages],
  [SUPPORTED_LOCALES.ES, esMessages],
  [SUPPORTED_LOCALES.EN, enMessages],
  [SUPPORTED_LOCALES.JA, jpMessages],
]);

const getLocaleMessages = locale => LOCALE_MESSAGES.get(locale);

const I18nProvider = ({ children }) => {
  const locale = getSupportedLocale(useAuthDataContext().locale);
  const messages = getLocaleMessages(locale);

  addLocaleData(getLocaleData(locale));
  moment.locale(locale);

  return (
    <IntlProvider locale={locale} messages={messages} formats={formats}>
      {children}
    </IntlProvider>
  );
};

export default I18nProvider;
